module.exports = __webpack_public_path__ + "img/banner.26600a5.jpg";